import accountBalance from "./accountBalance.js";
import logindevicetable from "./logindevicetable.js";
import newwalletTabel from "./newwalletTabel.js";
import otctable from "./otctable.js";
import paymentRecord from "./paymentRecord.js";
import payWithtable from "./payWithtable.js";
import takeover from "./takeover.js";
import userBehavior from "./userBehavior.js";
import userdetailsmain from "./userdetailsmain.js";
import userinformation from "./userinformation.js";
import usertabs from "./usertabs.js";
import walletTable from "./walletTable.js";
import otcTable from "./otcTable/index.js";

export default {
  accountBalance,
  logindevicetable,
  newwalletTabel,
  otctable,
  paymentRecord,
  payWithtable,
  takeover,
  userBehavior,
  userdetailsmain,
  userinformation,
  usertabs,
  walletTable,
  otcTable,
};
